import { useEffect, useState } from "react";

/**
 * Persist a client-side sort state ({key,dir}) in localStorage per page.
 * Use this for pages that already have their own inline sort state (Projects,
 * PaymentsReceived) instead of useTableSort.
 */
export function usePersistentSort(storageKey, defaultSort) {
  const [sort, setSort] = useState(() => {
    if (typeof window === "undefined") return defaultSort;
    try {
      const raw = window.localStorage.getItem(`sort:${storageKey}`);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.key && parsed.dir) return parsed;
      }
    } catch { /* ignore */ }
    return defaultSort;
  });
  useEffect(() => {
    try { window.localStorage.setItem(`sort:${storageKey}`, JSON.stringify(sort)); } catch { /* ignore */ }
  }, [sort, storageKey]);
  return [sort, setSort];
}
